import gsap from 'gsap';
import {playSplitText, playFade, showMagnetBtn} from '../common/help_functions';


export function initTitlePortfolio(element) {
    playFade('.portfolio-of-companies-section .number')
    playSplitText('.portfolio-of-companies-section .title', true);
    playFade('.portfolio-of-companies-section .description')
    merch_slider();
    showMagnetBtn('.portfolio-of-companies-section .btn-magnet')
}

function merch_slider() {

    const all_slide_count = $('.merch .item').length;

    function randomInteger(min, max) {
        let rand = min + Math.random() * (max + 1 - min);
        rand = Math.floor(rand);
        return rand;
    }

    function setDelay() {
        let random = randomInteger(0, 3);
        let current_slide = $('.merch .item').eq(random);

        gsap.to(current_slide, 0.5,
            {
                y: 40,
                opacity: 0,
                ease: "power1"
            }
        );
        setTimeout(function () {
            current_slide.toggleClass('hideSlide showSlide');

            //current slide.hide();
            let next_current_slide = $('.merch .item').eq(4);
            next_current_slide.insertAfter($('.merch .item').eq(random));
            next_current_slide.toggleClass('hideSlide showSlide ');

            // next current_slide.show();
            gsap.fromTo(next_current_slide, 0.5, {
                    y: 40,
                    opacity: 0,
                    ease: "power1"
                },
                {
                    y: 0,
                    opacity: 1,
                    ease: "power1"
                });
            current_slide.insertAfter($('.merch .item:last-child'));

        }, 800);
    }

    let timerId = setInterval(function () {
        setDelay();
    }, 3000);


}

